import { Component, computed, input, isSignal, OnInit, output, Signal } from '@angular/core';
import { Store, Uuid } from '@softline/core';
import { MessageBarConfig } from '../../data/message-bar.config';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../components/icon/icon.component';

@Component({
    selector: 'soft-message-bar',
    imports: [CommonModule, IconComponent],
    templateUrl: './message-bar.component.html',
    styleUrls: ['./message-bar.component.css'],
    standalone: true
})
export class MessageBarComponent implements OnInit {

  config = input.required<MessageBarConfig & {id: Uuid}>();

  title = computed(() => {
    const config = this.config();
    if(isSignal(config.title))
      return config.title();
    return config.title;
  });

  message = computed(() => {
    const config = this.config();
    if(isSignal(config.message))
      return config.message();
    return config.message;
  });

  icon = computed(() => {
    const config = this.config();
    if(isSignal(config.icon))
      return config.icon();
    return config.icon;
  });


  hasActions = computed(() =>
    (this.config().actions ?? []).length > 0
  )
  buttons = computed(() =>
    (this.config().actions ?? []).filter(o => o.type === 'button')
  );
  links = computed(() =>
    (this.config().actions ?? []).filter(o => o.type === 'link')
  );

  dismiss = output<MessageBarConfig>();

  constructor(private store: Store) {}

  ngOnInit(): void {}

  onDismiss(id?: string, callback?: () => void): void {
    if (callback)
      callback();
    this.dismiss.emit(this.config());
  }
}
